import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Estimation } from "src/app/domain/models/Route";

@Injectable({providedIn: 'root'})
export abstract class EstimationGateway {
  abstract getAllByFilter(countryFromId: number, portToId: number): Observable<Estimation[]>
}
